// extracted by mini-css-extract-plugin
module.exports = {"wrap":"structure_wrap__GBCEv","left":"structure_left__3Nrxb","right":"structure_right__2wYo4"};